import React from 'react';
import PropTypes from 'prop-types';
import Panel from 'wonderbly-components/lib/Panel';
import Button from 'wonderbly-components/lib/Button';
import RichText from '../Prismic/RichText';
import CountdownTimer from '../CountdownTimer';
import './SkipTheQueue.scss';

const SkipTheQueue = props => (
  <section className="skip-the-queue container-guttered">
    {props.helpButtonText && props.helpButtonUrl && (
      <Button
        outlined
        colour="green"
        className="skip-the-queue-help"
        href={props.helpButtonUrl}>
        {props.helpButtonText}
      </Button>
    )}
    <span className="skip-the-queue-heading">
      <RichText fields={props.title} />
      <CountdownTimer
        description={props.timeRemaining}
        secondsRemaining={props.currentOrder.editableSecondsRemaining}
      />
    </span>
    <Panel border="shadow">
      <RichText fields={props.description} />
      <form onSubmit={props.handleSubmit}>
        <div className="skip-the-queue-checkbox">
          <label>
            <input
              type="checkbox"
              name="confirmed"
              defaultChecked={props.values.confirmed}
              onChange={props.handleChange}
            />
            {props.checkboxLabel}
          </label>
        </div>
        <div className="skip-the-queue-buttons">
          <Button onClick={props.handleCancel}>{props.reviewOrder}</Button>
          <Button colour="green" disabled={!props.values.confirmed}>{props.confirm}</Button>
        </div>
      </form>
    </Panel>
  </section>
);

SkipTheQueue.propTypes = {
  title: PropTypes.array.isRequired,
  description: PropTypes.array.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  values: PropTypes.shape({
    confirmed: PropTypes.bool.isRequired,
  }).isRequired,
  currentOrder: PropTypes.shape({
    editableSecondsRemaining: PropTypes.number,
  }),
  timeRemaining: PropTypes.string.isRequired,
  checkboxLabel: PropTypes.string.isRequired,
  reviewOrder: PropTypes.string.isRequired,
  confirm: PropTypes.string.isRequired,
  helpButtonText: PropTypes.string,
  helpButtonUrl: PropTypes.string,
};

export default SkipTheQueue;



// WEBPACK FOOTER //
// ./src/client/js/view/components/SkipTheQueue/SkipTheQueue.js